import { AlertProps } from '../ui/components/Alert'
import { TagItemProps, TagsProps } from '../ui/components/Tags'

export enum ItemField {
  Name = 'name',
  Price = 'price',
  PriceTotal = 'priceTotal',
  Description = 'description',
  Image = 'image',
  Counter = 'counter',
  Tags = 'tags',
  Stock = 'stock',
  DescriptionStock = 'descriptionStock',
  Promotion = 'promotion',
  PromotionDetail = 'promotionDetail',
  PromotionTag = 'promotionTag',
  PromotionSavingLabel = 'promotionSavingLabel',
  ProductOptions = 'productOptions',
  ProductOptionsList = 'productOptionsList',
  PromotionsDetails = 'promotionsDetails',
  PromotionOrigin = 'promotionOrigin',
  LimitText = 'limitText',
  SimplePromotionTag = 'simplePromotionTag',
  ProductPackages = 'productPackages',
  VolumePromotions = 'volumePromotions'
}

export type ItemFieldsShowList = Record<ItemField, boolean>

export interface ItemTag extends TagItemProps {
  validator?: string | 'attributes'
  value?: string
}

export interface ItemExtensions {
  stock?: {
    active: boolean
    props?: AlertProps
  }
  tags?: {
    active: boolean
    props?: {
      items: ItemTag[]
    } & TagsProps
  }
}
